import {
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { RxFormGroup } from "@rxweb/reactive-form-validators";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { BroadcastService } from "../../../../../shared/services/broadcast.service";
import { FormService } from "../../../../../shared/services/form.service";
import { UnitssService } from "../../../../../services/unitss.service";
import { takeUntil } from "rxjs/operators";
import { UnitsModel } from "../models/units.model";
import { CustomersService } from "../../../../../services/customers.service";

@Component({
	selector: "app-edit-create-units",
	templateUrl: "./edit-create-units.component.html",
	styleUrls: ["./edit-create-units.component.scss"],
})
export class EditCreateUnitsComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	formGroup: RxFormGroup;

	fields: any = {
		name: {
			type: "input",
			options: {
				path: "name",
				class: "col-sm-12",
				label: {
					text: "Nombre",
					class: "col-sm-12",
				},
			},
		},
		client_id: {
			type: "select",
			options: {
				path: "client_id",
				label: {
					text: "Cliente",
				},
				dropdown: {
					text: "Seleccione...",
					options: [],
				},
			},
		},
		device_type_id: {
			type: "select",
			options: {
				path: "device_type_id",
				label: {
					text: "Tipo de unidad",
				},
				dropdown: {
					text: "Seleccione...",
					options: [],
				},
			},
		},
		raspberry_number: {
			type: "input",
			options: {
				path: "raspberry_number",
				class: "col-sm-12",
				label: {
					text: "Numero de Raspberry (MAC)",
					class: "col-sm-12",
				},
			},
		},
		raspberry_number_2: {
			type: "input",
			options: {
				path: "raspberry_number_2",
				class: "col-sm-12",
				label: {
					text: "Numero de Raspberry Auxiliar (MAC)",
					class: "col-sm-12",
				},
			},
		},
		router: {
			type: "input",
			options: {
				path: "router",
				class: "col-sm-12",
				label: {
					text: "Router",
					class: "col-sm-12",
				},
			},
		},
		phone_number: {
			type: "input",
			options: {
				path: "phone_number",
				class: "col-sm-12",
				label: {
					text: "Celular ESIM",
					class: "col-sm-12",
				},
			},
		},
		description: {
			type: "textarea",
			options: {
				path: "description",
				class: "col-sm-12",
				label: {
					text: "Descripcion",
					class: "col-sm-12",
				},
			},
		},
		active: {
			type: "switch",
			options: {
				path: "active",
				label: {
					text: "¿Activo?",
				},
				switchers: {
					trueCaption: "Si",
					falseCaption: "No",
				},
			},
		},
	};

	private atComponentDestroy = new Subject();

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private unitsService: UnitssService,
		private customersService: CustomersService,
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.formGroup = data;
			});
	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		await this.formService.transformIntoFormGroup(UnitsModel, this.data);
		// Cargar clientes si es admin y el campo está presente
		if (this.fields.client_id) {
			try {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
				this.fields.device_type_id.options.dropdown.options = [
						{ id: 1, name: "Comercial" },
						{ id: 2, name: "Prueba" },
					]
				const clientsResponse = await this.customersService.getAll();
				const clients = (clientsResponse.data ?? []).map((client) => ({
					id: client.id,
					name: client.name,
				}));
				this.fields.client_id.options.dropdown.options = [...clients];
			} catch (e) {
				console.error("Error al cargar clientes", e);
			}
		}else{
			this.fields.device_type_id.dropdown.options = [
						{ id: 1, name: "Comercial" }
					]
		}
		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.cdr.markForCheck();
			});
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		this.unitsService
			.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.broadcast.reloadDataTable();
				this.modalRef.hide();
			});
	}

	/**
	 * Helper function to transform an Object into an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme).map((key) => ({
			id: key,
			name: enumme[key],
		}));
	}
}
